import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import reservationApi from "../../../api/reservationApi";
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, Paper, Tooltip, Typography, useTheme } from "@mui/material";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import brokerApi from "../../../api/brokerApi";
import helper from "../../../helper";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"
import hotelApi from "../../../api/hotelApi";
import cityApi from "../../../api/cityApi";

import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import DownloadExcel from "../../../Components/DownloadExcel";


import { flatten } from 'flat'
import Excel from 'exceljs';
import { saveAs } from 'file-saver';

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MdEdit, MdEditSquare, MdExpandLess, MdExpandMore } from "react-icons/md";
import enumMapper from "../../../enumMapper";
import moment from 'jalali-moment'
import { NavLink } from "react-router-dom";
import hotelStructureApi from "../../../api/hotelStructureApi";
import brokerGroupApi from "../../../api/brokerGroupApi";
import CustomDateInput from "../../../Components/CustomDateInput";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { BsFileEarmarkExcel } from "react-icons/bs";
import staticVariablesApi from "../../../api/staticVariablesApi";

const InitialPlanList = () => {
  const theme = useTheme();
  //light or dark green
  const baseBackgroundColor =
    theme.palette.mode === 'dark'
      ? 'rgba(3, 44, 43, 1)'
      : '#fff';
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);

  //data and fetching state
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  //table state
  const [columnFilters, setColumnFilters] = useState(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });



  const [rows, setRows] = useState([]);
  const [loadingExcelData, setLoadingExcelData] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  const [hotelStructureIds, setHotelStructureIds] = useState([])
  const [Brokers, SetBrokers] = useState([]);
  const [HotelPlans, SetHotelPlans] = useState([]);
  const [loadingRows, setLoadingRows] = useState(false);
  const [HotelStructure, SetHotelStructure] = useState({});
  const [brokerGroups, setBrokerGroups] = useState([]);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'recordNumber',
        header: 'ردیف',
        size: 100,
        enableSorting: false,
      },
      {
        accessorKey: 'data.reserveInfo.cityName',
        id: 'cityName',
        header: 'شهر',
        size: 150,
        enableSorting: false,
      },
      {
        accessorKey: 'data.reserveInfo.hotelName',
        id: 'hotelName',
        header: 'هتل',
        size: 200,
        enableSorting: false,
      },
      {
        accessorKey: 'data.reserveInfo.brokerName',
        id: 'BrokerGroupInfo.NameOfBroker',
        header: 'کارگزار',
        size: 150,
      },
      {
        accessorKey: 'data.reserveInfo.brokerCode',
        id: 'BrokerGroupInfo.BrokerCode',
        header: 'شماره کارگزار',
        size: 150,
      },
      {
        accessorKey: 'data.reserveInfo.groupNumber',
        id: 'groupNumber',
        header: 'شماره گروه',
        size: 150,
        enableSorting: false,
      },
      {
        accessorKey: 'data.reserveInfo.capacity',
        id: 'capacity',
        header: 'ظرفیت',
        size: 150,
      },
      {
        accessorKey: 'data.reserveInfo.planCode',
        id: 'planCode',
        header: 'کد پلان',
        size: 150,
        enableSorting: false,
      },
      {
        accessorKey: 'data.reserveInfo.flightDate',
        id: 'BrokerGroupInfo.FlightDate',
        header: 'تاریخ پرواز',
        size: 150,
      },
      {
        accessorKey: 'data.reserveInfo.startDate',
        id: 'BrokerGroupInfo.StartDate',
        header: 'تاریخ تفویج',
        size: 150,
        enableSorting: false,
      },

    ],
    [],
  );



  const table = useMaterialReactTable({
    columns,
    data,
    enableRowSelection: true,
    // getRowId: (row) => row.phoneNumber,

    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    muiToolbarAlertBannerProps: isError
      ? {
        color: 'error',
        children: 'Error loading data',
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    }
    , localization: {

      sortByColumnAsc: '',
      sortByColumnDesc: '',
      sortedByColumnAsc: '',
      sortedByColumnDesc: '',

      // ... and many more - see link below for full list of translation keys
    },

    enableFilters: false,
    enableRowSelection: false
    , muiTableHeadCellProps: {
      //simple styling with the `sx` prop, works just like a style prop in this example
      sx: {
        textAlign: "left",
        backgroundColor: '#86A7FC'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        textAlign: 'left'
      },
    },
    muiTableBodyProps: {
      // sx: (theme) => ({
      //   '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
      //   {
      //     backgroundColor: darken(baseBackgroundColor, 0.1),
      //   },
      //   '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
      //   {
      //     backgroundColor: darken(baseBackgroundColor, 0.2),
      //   },
      //   '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
      //   {
      //     backgroundColor: lighten(baseBackgroundColor, 0.1),
      //   },
      //   '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
      //   {
      //     backgroundColor: darken(baseBackgroundColor, 0.2),
      //   },
      // }),
    },
    mrtTheme: (theme) => ({
      baseBackgroundColor: baseBackgroundColor,
      draggingBorderColor: theme.palette.secondary.main,
    }),

    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor: 'normal',
      },
    }),

    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
      'mrt-row-expand': {
        header: '', //change header text
        muiTableHeadCellProps: {
          align: 'right',
        },
        muiTableBodyCellProps: {
          align: 'right',
        },
      },
    },
    renderRowActions: ({ row, table }) => (

      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
        {
          AccessControl.checkPermissions(userPermissions, ["InitialPlan:Edit"]) ?
            <Tooltip title="ویرایش" placement="top">
              <IconButton disabled={row.original.isDeleted}
                component={NavLink} to={`/dashboard/InitialPlan/edit/${row.original.data.reserveInfo.id}`} sx={{ color: 'IconColor.main' }}><MdEditSquare />
              </IconButton></Tooltip>
            : <></>
        }
      </Box>
    ),


  });

  const schema = yup.object().shape({

  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
    defaultValues: {
      brokerId: null,
      cityConsistency: null,
      hotelId: null,
      planCode: null,
      flightDate: null
    },
    resolver: yupResolver(schema),
  });

  const getfilteritems = () => {
    const hotelId = watch("hotelId");
    const planCode = watch("planCode");
    const cityConsistency = watch("cityConsistency");

    // const brokerId=watch("brokerId");

    let flightDateGregorian = null;
    if (watch("flightDate")) {
      let flightDate = new DateObject({
        date: watch("flightDate"),
        calendar: persian,
        locale: persian_fa
      });

      var flightDateStr = flightDate.year + '/' + flightDate.month.number + '/' + flightDate.day;
      flightDateGregorian = moment.from(flightDateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }

    const filterItems = [];

    let startDateGregorian = null;
    if (watch("startDate")) {
      let startDate = new DateObject({
        date: watch("startDate"),
        calendar: persian,
        locale: persian_fa
      });

      var startDateStr = startDate.year + '/' + startDate.month.number + '/' + startDate.day;
      startDateGregorian = moment.from(startDateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }

    startDateGregorian && filterItems.push({
      "propertyName": "BrokerGroupInfo.StartDate",
      "operator": enumMapper.FilterOperator.Equals,
      "value": startDateGregorian
    })

    watch("brokerId") && filterItems.push({
      "propertyName": "BrokerGroupInfo.BrokerId",
      "operator": enumMapper.FilterOperator.Equals,
      "value": watch("brokerId")
    })

    watch("BrokerGroupId") && filterItems.push({
      "propertyName": "BrokerGroupInfo.BrokerGroupId",
      "operator": enumMapper.FilterOperator.Equals,
      "value": watch("BrokerGroupId")
    })

    watch("isActive") !== null && watch("isActive") !== undefined && filterItems.push({
      "propertyName": "IsActive",
      "operator": enumMapper.FilterOperator.Equals,
      "value": watch("isActive").toString()
    })

    const filterData = {
      "hotelId": hotelId,
      // "brokerId":brokerId,
      "planCode": parseInt(planCode),
      "cityConsistency": parseInt(cityConsistency),
      "flightDate": flightDateGregorian,
      "filters": filterItems,
      "orderBy": sorting.length > 0 ? sorting[0].id : 'CreateOn',
      "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
      "pageSize": pagination.pageSize,
      "pageNumber": pagination.pageIndex + 1
    }
    return filterData;
  }

  const onSubmit = (data) => {
    const filterData = getfilteritems();
    GetData(filterData);
  };

  useEffect(() => {
    GetCityDropDown();
    GetBrokerDropDown();
  }, [])

  useEffect(() => {
    const paginationModel = getfilteritems();
    GetData(paginationModel);
  }, [refresh,
    columnFilters, //re-fetch when column filters change
    globalFilter, //re-fetch when global filter changes
    pagination.pageIndex, //re-fetch when page index changes
    pagination.pageSize, //re-fetch when page size changes
    sorting, //re-fetch when sorting changes
  ]);

  const GetData = (filterData) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    reservationApi.FilterReserve(filterData)
      .then((res) => {
        setData(res.data.data.items);
        const rowcnt = res.data.data.totalCount;
        setRowCount(rowcnt);
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
      }).finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  }

  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
  }
  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };
  const GetBrokerDropDown = () => {
    brokerApi
      .BrokerDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        SetBrokers(arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        }))
      })
      .catch((error) => console.log(error));
  };
  const handleBrokerChanged = useCallback(async (id) => {
    // setBrokerInfo(null)
    if (id) {
      // GetBorkerByKey(id);
      const groupNumbers = await fetchBrokerGroupByBrokerId(id);
      setBrokerGroups(
        groupNumbers.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);

  const handlePlanChanged = (id) => { }
  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    resetField("planCode");
    resetField("hotelStructureId");
    setHotels(null);
    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };
  const handleHotelChanged = useCallback(async (id) => {
    // resetField("");      
    SetHotelStructure({});
    // setModirRoohaniRoomNumbers(null)
    resetField("planCode");
    // SetPlanInfoStructure(null);

    // if (id) {
    //     const hotelStructure = await fetchHotelStructureByHotelId(id);
    //     SetHotelStructure(hotelStructure);
    //     const hotelPlans = await fetchPlanHotelDropDown(id);
    //     const hotelPlansArr = helper.DictionayToList(hotelPlans);
    //     SetHotelPlans(hotelPlansArr.map((item) => {
    //         return {
    //             label: item.value,
    //             id: item.key
    //         };
    //     }))


    // }

    setHotelStructureIds([]);
    resetField("hotelStructureId")
    if (id) {
      const hotelStructureIds = await fetchHotelStrutureDropDown(id);
      const arr = helper.DictionayToList(hotelStructureIds);
      const mappedReponse = arr.map((r) => {
        return {
          id: r.key,
          label: r.value
        };
      });
      setHotelStructureIds(mappedReponse);

      if (arr.length === 1) {
        setValue("hotelStructureId", arr[0].key);
        GetPlanHotelDropDown(arr[0].key);
      }




    }

  }, []);

  const fetchPlanHotelDropDown = async (hotelId) => {
    try {
      let res = await hotelApi.PlanCodeHotelDropDown(hotelId, false);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };


  const handleHotelStructureIdChanged = async (id) => {

    // resetField("");
    SetHotelStructure(null);
    if (id) {

      const hotelStructure = await fetchHotelStructureById(id);
      SetHotelStructure(hotelStructure);
      GetPlanHotelDropDown(id);
    }
  };
  const fetchHotelStructureById = async (id) => {
    try {
      let res = await hotelStructureApi.GetHotelStructure(id);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };

  const GetPlanHotelDropDown = (structureId) => {
    hotelStructureApi.PlanCodeHotelStructureDropDown(structureId).then(res => {
      const arr = helper.DictionayToList(res.data.data);
      SetHotelPlans(arr.map((item) => {
        return {
          id: item.key,
          label: item.value
        };
      }));
    }).catch(err => console.log(err));
  };
  const handleBrokerGroupChanged = async (id) => {

  }
  const fetchHotelStrutureDropDown = async (hotelId) => {
    try {
      let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const fetchBrokerGroupByBrokerId = async (brokerId) => {
    try {
      let res = await brokerGroupApi.BrokerGroupDropDown(brokerId);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };

  const saveExcel = async (data2, columns, title) => {

    const workSheetName = 'Sheet1';
    const workBookName = title;
    const workbook = new Excel.Workbook();

    try {
      const fileName = workBookName;

      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);
      worksheet.views = [{ rightToLeft: true }];
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;

      // updated the font for first row.
      worksheet.getRow(1).font = { bold: true };

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach(column => {
        column.width = column.header.length + 5;
        column.alignment = { horizontal: 'center' };

      });

      // loop through data and add each one to worksheet
      data2.forEach(singleData => {
        worksheet.addRow(singleData);
      });

      // loop through all of the rows and set the outline style.
      worksheet.eachRow({ includeEmpty: false }, row => {
        // store each cell to currentCell
        const currentCell = row._cells;

        // loop through currentCell to apply border only for the non-empty cell of excel
        currentCell.forEach(singleCell => {
          // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
          const cellAddress = singleCell._address;

          // apply border
          // worksheet.getCell(cellAddress).border = {
          //   top: { style: 'thin' },
          //   left: { style: 'thin' },
          //   bottom: { style: 'thin' },
          //   right: { style: 'thin' }
          // };
        });
      });

      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();

      // download the processed file
      saveAs(new Blob([buf]), `${fileName}.xlsx`);
    } catch (error) {
      console.error('<<<ERRROR>>>', error);
      console.error('Something Went Wrong', error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };


  const handleExcelClick = () => {
    setLoadingExcelData(true);
    const filterData = getfilteritems();
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    reservationApi.FilterReserve(filterData)
      .then((res) => {
        setData(res.data.data.items);
        const rowcnt = res.data.data.totalCount;
        setRowCount(rowcnt);

        /////////////////////////////////////////////////
        const filterData2 = getfilteritems();
        filterData2.pageNumber = 1;
        filterData2.pageSize = rowcnt;
        reservationApi.FilterReserve(filterData2).then(excelRes => {
          const columns = [
            // { header: 'شناسه سفارش', key: 'paymentId' },
            // { header: 'نام', key: 'firstName' },
            // { header: 'نام خانوادگی', key: 'lastName' },
            // { header: 'کد ملی', key: 'ssn' },
            // { header: 'نسبت', key: 'degreeOfRelativityTitle' },
            // { header: 'هزینه سفر', key: 'amountText' },
            // { header: '', key: 'currencyName' },
            // { header: 'وضعیت پرداخت', key: 'statusTitle' },
            // { header: 'تاریخ پرداخت', key: 'persian_PaidDate' },
            // { header: 'نفر اصلی', key: 'agent' },
            { header: 'شهر', key: 'cityName' },
            { header: 'هتل', key: 'hotelName' },
            { header: 'کارگزار', key: 'brokerName' },
            { header: 'شماره کارگزار', key: 'brokerCode' },
            { header: 'شماره گروه', key: 'groupNumber' },
            { header: 'ظرفیت', key: 'capacity' },
            { header: 'کد پلان', key: 'planCode' },
            { header: 'تاریخ پرواز', key: 'flightDate' }

          ]


          let arr = [];
          if (excelRes.data.data.items) {
            for (let index = 0; index < excelRes.data.data.items.length; index++) {
              const element = excelRes.data.data.items[index];
              const element2 = element.data.reserveInfo;
              arr.push(flatten(element2, {
                maxDepth: 4
              }))
            }
            saveExcel(arr, columns, "پلان اقامتی کارگزار");
          }

        }).catch(excelErr => console.log(excelErr))
          .finally(() => setLoadingExcelData(false))
        /////////////////////////////////////////////////
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
      }).finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  }

  return (
    <RtlProvider>
      <form onSubmit={handleSubmit(onSubmit)}>

        <Typography component="h1" variant="h5" mb={2}>لیست پلان اقامتی کارگزار</Typography>
        <Grid container spacing={1}>

          <Grid item xs={12} sm={1}>
            <RHFAutocomplete
              control={control}
              options={Cities ?? []}
              name="cityConsistency"
              placeholder="شهر"
              onChange={handleCityChanged}
              disabled={Cities === null}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={Hotels ?? []}
              name="hotelId"
              placeholder="هتل"
              onChange={handleHotelChanged}
              disabled={Cities === null}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              loading={watch("hotelId") && !hotelStructureIds?.length}
              control={control}
              options={hotelStructureIds ?? []}
              name="hotelStructureId"
              placeholder="ساختار"
              onChange={handleHotelStructureIdChanged}
              disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
              style={{
                border: "none",
                padding: 0,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={HotelPlans ?? []}
              name="planCode"
              placeholder="کد پلان"
              onChange={handlePlanChanged}
            />

          </Grid>

          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={Brokers ?? []}
              name="brokerId"
              placeholder="کارگزار"
              onChange={handleBrokerChanged}
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <RHFAutocomplete
              control={control}
              options={brokerGroups ?? []}
              name="BrokerGroupId"
              placeholder="گروه"
              onChange={handleBrokerGroupChanged}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Controller
              control={control}
              name="flightDate"
              rules={{ required: true }}
              render={({
                field: { onChange, name, value },
                fieldState: { invalid, isDirty },
              }) => (
                <>
                  <DatePicker
                    value={value || ""}
                    onChange={(date) => {
                      onChange(date?.isValid ? date : "");
                    }}
                    format={"YYYY/MM/DD"}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    render={<CustomDateInput label={"تاریخ پرواز"} />}
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Controller
              control={control}
              name="startDate"
              rules={{ required: true }}
              render={({
                field: { onChange, name, value },
                fieldState: { invalid, isDirty },
              }) => (
                <>
                  <DatePicker
                    value={value || ""}
                    onChange={(date) => {
                      onChange(date?.isValid ? date : "");
                    }}
                    format={"YYYY/MM/DD"}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    render={<CustomDateInput label={"تاریخ تفویج"} />}
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormControlLabel
              control={
                <Controller
                  name="isActive"
                  control={control}
                  defaultValue={true}
                  render={({ field: { value, ref, ...field } }) => (
                    <Checkbox
                      {...field}
                      inputRef={ref}
                      checked={!!value}
                      color="primary"
                      size={"medium"}
                      disableRipple
                    />
                  )}
                />
              }
              label="فعال"
              labelPlacement="end"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button type="submit" variant="contained" color="secondary">جستجو</Button>
          </Grid>
        </Grid>
        {/* <br />
        {rows.length > 0 &&
          (<Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <DownloadExcel
              columns={[
              { header: 'شهر', key: 'cityName' },
              { header: 'هتل', key: 'hotelName' },
              { header: 'کارگزار', key: 'brokerName' },
              { header: 'شماره کارگزار', key: 'brokerCode' },
              { header: 'شماره گروه', key: 'groupNumber' },
              { header: 'ظرفیت', key: 'capacity' },
              { header: 'کد پلان', key: 'planCode' },
              { header: 'تاریخ پرواز', key: 'flightDate' }]}

              data={rows}
              title={"پلان اقامتی کارگزار"}
            />
          </Box>
          )} */}
        {/* <Paper sx={{ width: "100%", height: "600px" }}>
          <CustomDataGrid
            rows={rows}
            columns={columns}
            loading={loadingRows}
            deleteApi={reservationApi}
            refreshGrid={RefreshGrid}
            editUrl={`/dashboard/InitialPlan/edit`}
            showDelete={AccessControl.checkPermissions(userPermissions, ["InitialPlan:Delete"])}
            showEdit={AccessControl.checkPermissions(userPermissions, ["InitialPlan:Edit"])}
          />
        </Paper> */}

      </form>
      <Box sx={{ display: "flex", flexDirection: 'column' }}>
        {rowCount > 0 &&
          (<Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Tooltip title="دانلود اکسل" placement="top">
              <IconButton type="button" onClick={handleExcelClick} disabled={loadingExcelData}>
                <BeatLoading loading={loadingExcelData} color={"#e65100"} size={8} /><BsFileEarmarkExcel size={30} color={loadingExcelData ? "#eee" : "#1e6e42"} />
              </IconButton>
            </Tooltip>
          </Box>
          )}
        <Box sx={{ textAlign: "right", mb: 2, mr: 1.5 }}>تعداد نتایج: {rowCount}</Box>
      </Box>
      <MaterialReactTable table={table} />
    </RtlProvider>
  );
}

export default InitialPlanList;
